module.exports = __webpack_public_path__ + "static/media/chat.20034a15.jpg";